import { TSL as t } from "./three.webgpu.js";
/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const e = t.BRDF_GGX, n = t.BRDF_Lambert, s = t.BasicShadowFilter, r = t.Break, c = t.Continue, a = t.DFGApprox, i = t.D_GGX, l = t.Discard, m = t.EPSILON, p = t.F_Schlick, d = t.Fn, u = t.INFINITY, g = t.If, h = t.Loop, f = t.NodeShaderStage, x = t.NodeType, b = t.NodeUpdateType, w = t.NodeAccess, v = t.PCFShadowFilter, S = t.PCFSoftShadowFilter, T = t.PI, _ = t.PI2, V = t.Return, y = t.Schlick_to_F0, D = t.ScriptableNodeResources, M = t.ShaderNode, F = t.TBNViewMatrix, C = t.VSMShadowFilter, I = t.V_GGX_SmithCorrelated, N = t.abs, P = t.acesFilmicToneMapping, R = t.acos, B = t.add, L = t.addNodeElement, k = t.agxToneMapping, A = t.all, G = t.alphaT, O = t.and, W = t.anisotropy, j = t.anisotropyB, U = t.anisotropyT, q = t.any, z = t.append, E = t.arrayBuffer, Z = t.asin, X = t.assign, Y = t.atan, H = t.atan2, J = t.atomicAdd, K = t.atomicAnd, Q = t.atomicFunc, $ = t.atomicMax, tt = t.atomicMin, ot = t.atomicOr, et = t.atomicStore, nt = t.atomicSub, st = t.atomicXor, rt = t.attenuationColor, ct = t.attenuationDistance, at = t.attribute, it = t.attributeArray, lt = t.backgroundBlurriness, mt = t.backgroundIntensity, pt = t.backgroundRotation, dt = t.batch, ut = t.billboarding, gt = t.bitAnd, ht = t.bitNot, ft = t.bitOr, xt = t.bitXor, bt = t.bitangentGeometry, wt = t.bitangentLocal, vt = t.bitangentView, St = t.bitangentWorld, Tt = t.bitcast, _t = t.blendBurn, Vt = t.blendColor, yt = t.blendDodge, Dt = t.blendOverlay, Mt = t.blendScreen, Ft = t.blur, Ct = t.bool, It = t.buffer, Nt = t.bufferAttribute, Pt = t.bumpMap, Rt = t.burn, Bt = t.bvec2, Lt = t.bvec3, kt = t.bvec4, At = t.bypass, Gt = t.cache, Ot = t.call, Wt = t.cameraFar, jt = t.cameraNear, Ut = t.cameraNormalMatrix, qt = t.cameraPosition, zt = t.cameraProjectionMatrix, Et = t.cameraProjectionMatrixInverse, Zt = t.cameraViewMatrix, Xt = t.cameraWorldMatrix, Yt = t.cbrt, Ht = t.cdl, Jt = t.ceil, Kt = t.checker, Qt = t.cineonToneMapping, $t = t.clamp, to = t.clearcoat, oo = t.clearcoatRoughness, eo = t.code, no = t.color, so = t.colorSpaceToWorking, ro = t.colorToDirection, co = t.compute, ao = t.cond, io = t.context, lo = t.convert, mo = t.convertColorSpace, po = t.convertToTexture, uo = t.cos, go = t.cross, ho = t.cubeTexture, fo = t.dFdx, xo = t.dFdy, bo = t.dashSize, wo = t.defaultBuildStages, vo = t.defaultShaderStages, So = t.defined, To = t.degrees, _o = t.deltaTime, Vo = t.densityFog, yo = t.densityFogFactor, Do = t.depth, Mo = t.depthPass, Fo = t.difference, Co = t.diffuseColor, Io = t.directPointLight, No = t.directionToColor, Po = t.dispersion, Ro = t.distance, Bo = t.div, Lo = t.dodge, ko = t.dot, Ao = t.drawIndex, Go = t.dynamicBufferAttribute, Oo = t.element, Wo = t.emissive, jo = t.equal, Uo = t.equals, qo = t.equirectUV, zo = t.exp, Eo = t.exp2, Zo = t.expression, Xo = t.faceDirection, Yo = t.faceForward, Ho = t.faceforward, Jo = t.float, Ko = t.floor, Qo = t.fog, $o = t.fract, te = t.frameGroup, oe = t.frameId, ee = t.frontFacing, ne = t.fwidth, se = t.gain, re = t.gapSize, ce = t.getConstNodeType, ae = t.getCurrentStack, ie = t.getDirection, le = t.getDistanceAttenuation, me = t.getGeometryRoughness, pe = t.getNormalFromDepth, de = t.getParallaxCorrectNormal, ue = t.getRoughness, ge = t.getScreenPosition, he = t.getShIrradianceAt, fe = t.getTextureIndex, xe = t.getViewPosition, be = t.glsl, we = t.glslFn, ve = t.grayscale, Se = t.greaterThan, Te = t.greaterThanEqual, _e = t.hash, Ve = t.highpModelNormalViewMatrix, ye = t.highpModelViewMatrix, De = t.hue, Me = t.instance, Fe = t.instanceIndex, Ce = t.instancedArray, Ie = t.instancedBufferAttribute, Ne = t.instancedDynamicBufferAttribute, Pe = t.instancedMesh, Re = t.int, Be = t.inverseSqrt, Le = t.inversesqrt, ke = t.invocationLocalIndex, Ae = t.invocationSubgroupIndex, Ge = t.ior, Oe = t.iridescence, We = t.iridescenceIOR, je = t.iridescenceThickness, Ue = t.ivec2, qe = t.ivec3, ze = t.ivec4, Ee = t.js, Ze = t.label, Xe = t.length, Ye = t.lengthSq, He = t.lessThan, Je = t.lessThanEqual, Ke = t.lightPosition, Qe = t.lightTargetDirection, $e = t.lightTargetPosition, tn = t.lightViewPosition, on = t.lightingContext, en = t.lights, nn = t.linearDepth, sn = t.linearToneMapping, rn = t.localId, cn = t.log, an = t.log2, ln = t.logarithmicDepthToViewZ, mn = t.loop, pn = t.luminance, dn = t.mediumpModelViewMatrix, un = t.mat2, gn = t.mat3, hn = t.mat4, fn = t.matcapUV, xn = t.materialAO, bn = t.materialAlphaTest, wn = t.materialAnisotropy, vn = t.materialAnisotropyVector, Sn = t.materialAttenuationColor, Tn = t.materialAttenuationDistance, _n = t.materialClearcoat, Vn = t.materialClearcoatNormal, yn = t.materialClearcoatRoughness, Dn = t.materialColor, Mn = t.materialDispersion, Fn = t.materialEmissive, Cn = t.materialIOR, In = t.materialIridescence, Nn = t.materialIridescenceIOR, Pn = t.materialIridescenceThickness, Rn = t.materialLightMap, Bn = t.materialLineDashOffset, Ln = t.materialLineDashSize, kn = t.materialLineGapSize, An = t.materialLineScale, Gn = t.materialLineWidth, On = t.materialMetalness, Wn = t.materialNormal, jn = t.materialOpacity, Un = t.materialPointWidth, qn = t.materialReference, zn = t.materialReflectivity, En = t.materialRefractionRatio, Zn = t.materialRotation, Xn = t.materialRoughness, Yn = t.materialSheen, Hn = t.materialSheenRoughness, Jn = t.materialShininess, Kn = t.materialSpecular, Qn = t.materialSpecularColor, $n = t.materialSpecularIntensity, ts = t.materialSpecularStrength, os = t.materialThickness, es = t.materialTransmission, ns = t.max, ss = t.maxMipLevel, rs = t.metalness, cs = t.min, as = t.mix, is = t.mixElement, ls = t.mod, ms = t.modInt, ps = t.modelDirection, ds = t.modelNormalMatrix, us = t.modelPosition, gs = t.modelScale, hs = t.modelViewMatrix, fs = t.modelViewPosition, xs = t.modelViewProjection, bs = t.modelWorldMatrix, ws = t.modelWorldMatrixInverse, vs = t.morphReference, Ss = t.mrt, Ts = t.mul, _s = t.mx_aastep, Vs = t.mx_cell_noise_float, ys = t.mx_contrast, Ds = t.mx_fractal_noise_float, Ms = t.mx_fractal_noise_vec2, Fs = t.mx_fractal_noise_vec3, Cs = t.mx_fractal_noise_vec4, Is = t.mx_hsvtorgb, Ns = t.mx_noise_float, Ps = t.mx_noise_vec3, Rs = t.mx_noise_vec4, Bs = t.mx_ramplr, Ls = t.mx_ramptb, ks = t.mx_rgbtohsv, As = t.mx_safepower, Gs = t.mx_splitlr, Os = t.mx_splittb, Ws = t.mx_srgb_texture_to_lin_rec709, js = t.mx_transform_uv, Us = t.mx_worley_noise_float, qs = t.mx_worley_noise_vec2, zs = t.mx_worley_noise_vec3, Es = t.negate, Zs = t.neutralToneMapping, Xs = t.nodeArray, Ys = t.nodeImmutable, Hs = t.nodeObject, Js = t.nodeObjects, Ks = t.nodeProxy, Qs = t.normalFlat, $s = t.normalGeometry, tr = t.normalLocal, or = t.normalMap, er = t.normalView, nr = t.normalWorld, sr = t.normalize, rr = t.not, cr = t.notEqual, ar = t.numWorkgroups, ir = t.objectDirection, lr = t.objectGroup, mr = t.objectPosition, pr = t.objectScale, dr = t.objectViewPosition, ur = t.objectWorldMatrix, gr = t.oneMinus, hr = t.or, fr = t.orthographicDepthToViewZ, xr = t.oscSawtooth, br = t.oscSine, wr = t.oscSquare, vr = t.oscTriangle, Sr = t.output, Tr = t.outputStruct, _r = t.overlay, Vr = t.overloadingFn, yr = t.parabola, Dr = t.parallaxDirection, Mr = t.parallaxUV, Fr = t.parameter, Cr = t.pass, Ir = t.passTexture, Nr = t.pcurve, Pr = t.perspectiveDepthToViewZ, Rr = t.pmremTexture, Br = t.pointUV, Lr = t.pointWidth, kr = t.positionGeometry, Ar = t.positionLocal, Gr = t.positionPrevious, Or = t.positionView, Wr = t.positionViewDirection, jr = t.positionWorld, Ur = t.positionWorldDirection, qr = t.posterize, zr = t.pow, Er = t.pow2, Zr = t.pow3, Xr = t.pow4, Yr = t.property, Hr = t.radians, Jr = t.rand, Kr = t.range, Qr = t.rangeFog, $r = t.rangeFogFactor, tc = t.reciprocal, oc = t.reference, ec = t.referenceBuffer, nc = t.reflect, sc = t.reflectVector, rc = t.reflectView, cc = t.reflector, ac = t.refract, ic = t.refractVector, lc = t.refractView, mc = t.reinhardToneMapping, pc = t.remainder, dc = t.remap, uc = t.remapClamp, gc = t.renderGroup, hc = t.renderOutput, fc = t.rendererReference, xc = t.rotate, bc = t.rotateUV, wc = t.roughness, vc = t.round, Sc = t.rtt, Tc = t.sRGBTransferEOTF, _c = t.sRGBTransferOETF, Vc = t.sampler, yc = t.saturate, Dc = t.saturation, Mc = t.screen, Fc = t.screenCoordinate, Cc = t.screenSize, Ic = t.screenUV, Nc = t.scriptable, Pc = t.scriptableValue, Rc = t.select, Bc = t.setCurrentStack, Lc = t.shaderStages, kc = t.shadow, Ac = t.shadowPositionWorld, Gc = t.sharedUniformGroup, Oc = t.sheen, Wc = t.sheenRoughness, jc = t.shiftLeft, Uc = t.shiftRight, qc = t.shininess, zc = t.sign, Ec = t.sin, Zc = t.sinc, Xc = t.skinning, Yc = t.skinningReference, Hc = t.smoothstep, Jc = t.smoothstepElement, Kc = t.specularColor, Qc = t.specularF90, $c = t.spherizeUV, ta = t.split, oa = t.spritesheetUV, ea = t.sqrt, na = t.stack, sa = t.step, ra = t.storage, ca = t.storageBarrier, aa = t.storageObject, ia = t.storageTexture, la = t.string, ma = t.sub, pa = t.subgroupIndex, da = t.subgroupSize, ua = t.tan, ga = t.tangentGeometry, ha = t.tangentLocal, fa = t.tangentView, xa = t.tangentWorld, ba = t.temp, wa = t.texture, va = t.texture3D, Sa = t.textureBarrier, Ta = t.textureBicubic, _a = t.textureCubeUV, Va = t.textureLoad, ya = t.textureSize, Da = t.textureStore, Ma = t.thickness, Fa = t.threshold, Ca = t.time, Ia = t.timerDelta, Na = t.timerGlobal, Pa = t.timerLocal, Ra = t.toOutputColorSpace, Ba = t.toWorkingColorSpace, La = t.toneMapping, ka = t.toneMappingExposure, Aa = t.toonOutlinePass, Ga = t.transformDirection, Oa = t.transformNormal, Wa = t.transformNormalToView, ja = t.transformedBentNormalView, Ua = t.transformedBitangentView, qa = t.transformedBitangentWorld, za = t.transformedClearcoatNormalView, Ea = t.transformedNormalView, Za = t.transformedNormalWorld, Xa = t.transformedTangentView, Ya = t.transformedTangentWorld, Ha = t.transmission, Ja = t.transpose, Ka = t.tri, Qa = t.tri3, $a = t.triNoise3D, ti = t.triplanarTexture, oi = t.triplanarTextures, ei = t.trunc, ni = t.tslFn, si = t.uint, ri = t.uniform, ci = t.uniformArray, ai = t.uniformGroup, ii = t.uniforms, li = t.userData, mi = t.uv, pi = t.uvec2, di = t.uvec3, ui = t.uvec4, gi = t.varying, hi = t.varyingProperty, fi = t.vec2, xi = t.vec3, bi = t.vec4, wi = t.vectorComponents, vi = t.velocity, Si = t.vertexColor, Ti = t.vertexIndex, _i = t.vibrance, Vi = t.viewZToLogarithmicDepth, yi = t.viewZToOrthographicDepth, Di = t.viewZToPerspectiveDepth, Mi = t.viewport, Fi = t.viewportBottomLeft, Ci = t.viewportCoordinate, Ii = t.viewportDepthTexture, Ni = t.viewportLinearDepth, Pi = t.viewportMipTexture, Ri = t.viewportResolution, Bi = t.viewportSafeUV, Li = t.viewportSharedTexture, ki = t.viewportSize, Ai = t.viewportTexture, Gi = t.viewportTopLeft, Oi = t.viewportUV, Wi = t.wgsl, ji = t.wgslFn, Ui = t.workgroupArray, qi = t.workgroupBarrier, zi = t.workgroupId, Ei = t.workingToColorSpace, Zi = t.xor;
export {
  e as BRDF_GGX,
  n as BRDF_Lambert,
  s as BasicShadowFilter,
  r as Break,
  c as Continue,
  a as DFGApprox,
  i as D_GGX,
  l as Discard,
  m as EPSILON,
  p as F_Schlick,
  d as Fn,
  u as INFINITY,
  g as If,
  h as Loop,
  w as NodeAccess,
  f as NodeShaderStage,
  x as NodeType,
  b as NodeUpdateType,
  v as PCFShadowFilter,
  S as PCFSoftShadowFilter,
  T as PI,
  _ as PI2,
  V as Return,
  y as Schlick_to_F0,
  D as ScriptableNodeResources,
  M as ShaderNode,
  F as TBNViewMatrix,
  C as VSMShadowFilter,
  I as V_GGX_SmithCorrelated,
  N as abs,
  P as acesFilmicToneMapping,
  R as acos,
  B as add,
  L as addNodeElement,
  k as agxToneMapping,
  A as all,
  G as alphaT,
  O as and,
  W as anisotropy,
  j as anisotropyB,
  U as anisotropyT,
  q as any,
  z as append,
  E as arrayBuffer,
  Z as asin,
  X as assign,
  Y as atan,
  H as atan2,
  J as atomicAdd,
  K as atomicAnd,
  Q as atomicFunc,
  $ as atomicMax,
  tt as atomicMin,
  ot as atomicOr,
  et as atomicStore,
  nt as atomicSub,
  st as atomicXor,
  rt as attenuationColor,
  ct as attenuationDistance,
  at as attribute,
  it as attributeArray,
  lt as backgroundBlurriness,
  mt as backgroundIntensity,
  pt as backgroundRotation,
  dt as batch,
  ut as billboarding,
  gt as bitAnd,
  ht as bitNot,
  ft as bitOr,
  xt as bitXor,
  bt as bitangentGeometry,
  wt as bitangentLocal,
  vt as bitangentView,
  St as bitangentWorld,
  Tt as bitcast,
  _t as blendBurn,
  Vt as blendColor,
  yt as blendDodge,
  Dt as blendOverlay,
  Mt as blendScreen,
  Ft as blur,
  Ct as bool,
  It as buffer,
  Nt as bufferAttribute,
  Pt as bumpMap,
  Rt as burn,
  Bt as bvec2,
  Lt as bvec3,
  kt as bvec4,
  At as bypass,
  Gt as cache,
  Ot as call,
  Wt as cameraFar,
  jt as cameraNear,
  Ut as cameraNormalMatrix,
  qt as cameraPosition,
  zt as cameraProjectionMatrix,
  Et as cameraProjectionMatrixInverse,
  Zt as cameraViewMatrix,
  Xt as cameraWorldMatrix,
  Yt as cbrt,
  Ht as cdl,
  Jt as ceil,
  Kt as checker,
  Qt as cineonToneMapping,
  $t as clamp,
  to as clearcoat,
  oo as clearcoatRoughness,
  eo as code,
  no as color,
  so as colorSpaceToWorking,
  ro as colorToDirection,
  co as compute,
  ao as cond,
  io as context,
  lo as convert,
  mo as convertColorSpace,
  po as convertToTexture,
  uo as cos,
  go as cross,
  ho as cubeTexture,
  fo as dFdx,
  xo as dFdy,
  bo as dashSize,
  wo as defaultBuildStages,
  vo as defaultShaderStages,
  So as defined,
  To as degrees,
  _o as deltaTime,
  Vo as densityFog,
  yo as densityFogFactor,
  Do as depth,
  Mo as depthPass,
  Fo as difference,
  Co as diffuseColor,
  Io as directPointLight,
  No as directionToColor,
  Po as dispersion,
  Ro as distance,
  Bo as div,
  Lo as dodge,
  ko as dot,
  Ao as drawIndex,
  Go as dynamicBufferAttribute,
  Oo as element,
  Wo as emissive,
  jo as equal,
  Uo as equals,
  qo as equirectUV,
  zo as exp,
  Eo as exp2,
  Zo as expression,
  Xo as faceDirection,
  Yo as faceForward,
  Ho as faceforward,
  Jo as float,
  Ko as floor,
  Qo as fog,
  $o as fract,
  te as frameGroup,
  oe as frameId,
  ee as frontFacing,
  ne as fwidth,
  se as gain,
  re as gapSize,
  ce as getConstNodeType,
  ae as getCurrentStack,
  ie as getDirection,
  le as getDistanceAttenuation,
  me as getGeometryRoughness,
  pe as getNormalFromDepth,
  de as getParallaxCorrectNormal,
  ue as getRoughness,
  ge as getScreenPosition,
  he as getShIrradianceAt,
  fe as getTextureIndex,
  xe as getViewPosition,
  be as glsl,
  we as glslFn,
  ve as grayscale,
  Se as greaterThan,
  Te as greaterThanEqual,
  _e as hash,
  Ve as highpModelNormalViewMatrix,
  ye as highpModelViewMatrix,
  De as hue,
  Me as instance,
  Fe as instanceIndex,
  Ce as instancedArray,
  Ie as instancedBufferAttribute,
  Ne as instancedDynamicBufferAttribute,
  Pe as instancedMesh,
  Re as int,
  Be as inverseSqrt,
  Le as inversesqrt,
  ke as invocationLocalIndex,
  Ae as invocationSubgroupIndex,
  Ge as ior,
  Oe as iridescence,
  We as iridescenceIOR,
  je as iridescenceThickness,
  Ue as ivec2,
  qe as ivec3,
  ze as ivec4,
  Ee as js,
  Ze as label,
  Xe as length,
  Ye as lengthSq,
  He as lessThan,
  Je as lessThanEqual,
  Ke as lightPosition,
  Qe as lightTargetDirection,
  $e as lightTargetPosition,
  tn as lightViewPosition,
  on as lightingContext,
  en as lights,
  nn as linearDepth,
  sn as linearToneMapping,
  rn as localId,
  cn as log,
  an as log2,
  ln as logarithmicDepthToViewZ,
  mn as loop,
  pn as luminance,
  un as mat2,
  gn as mat3,
  hn as mat4,
  fn as matcapUV,
  xn as materialAO,
  bn as materialAlphaTest,
  wn as materialAnisotropy,
  vn as materialAnisotropyVector,
  Sn as materialAttenuationColor,
  Tn as materialAttenuationDistance,
  _n as materialClearcoat,
  Vn as materialClearcoatNormal,
  yn as materialClearcoatRoughness,
  Dn as materialColor,
  Mn as materialDispersion,
  Fn as materialEmissive,
  Cn as materialIOR,
  In as materialIridescence,
  Nn as materialIridescenceIOR,
  Pn as materialIridescenceThickness,
  Rn as materialLightMap,
  Bn as materialLineDashOffset,
  Ln as materialLineDashSize,
  kn as materialLineGapSize,
  An as materialLineScale,
  Gn as materialLineWidth,
  On as materialMetalness,
  Wn as materialNormal,
  jn as materialOpacity,
  Un as materialPointWidth,
  qn as materialReference,
  zn as materialReflectivity,
  En as materialRefractionRatio,
  Zn as materialRotation,
  Xn as materialRoughness,
  Yn as materialSheen,
  Hn as materialSheenRoughness,
  Jn as materialShininess,
  Kn as materialSpecular,
  Qn as materialSpecularColor,
  $n as materialSpecularIntensity,
  ts as materialSpecularStrength,
  os as materialThickness,
  es as materialTransmission,
  ns as max,
  ss as maxMipLevel,
  dn as mediumpModelViewMatrix,
  rs as metalness,
  cs as min,
  as as mix,
  is as mixElement,
  ls as mod,
  ms as modInt,
  ps as modelDirection,
  ds as modelNormalMatrix,
  us as modelPosition,
  gs as modelScale,
  hs as modelViewMatrix,
  fs as modelViewPosition,
  xs as modelViewProjection,
  bs as modelWorldMatrix,
  ws as modelWorldMatrixInverse,
  vs as morphReference,
  Ss as mrt,
  Ts as mul,
  _s as mx_aastep,
  Vs as mx_cell_noise_float,
  ys as mx_contrast,
  Ds as mx_fractal_noise_float,
  Ms as mx_fractal_noise_vec2,
  Fs as mx_fractal_noise_vec3,
  Cs as mx_fractal_noise_vec4,
  Is as mx_hsvtorgb,
  Ns as mx_noise_float,
  Ps as mx_noise_vec3,
  Rs as mx_noise_vec4,
  Bs as mx_ramplr,
  Ls as mx_ramptb,
  ks as mx_rgbtohsv,
  As as mx_safepower,
  Gs as mx_splitlr,
  Os as mx_splittb,
  Ws as mx_srgb_texture_to_lin_rec709,
  js as mx_transform_uv,
  Us as mx_worley_noise_float,
  qs as mx_worley_noise_vec2,
  zs as mx_worley_noise_vec3,
  Es as negate,
  Zs as neutralToneMapping,
  Xs as nodeArray,
  Ys as nodeImmutable,
  Hs as nodeObject,
  Js as nodeObjects,
  Ks as nodeProxy,
  Qs as normalFlat,
  $s as normalGeometry,
  tr as normalLocal,
  or as normalMap,
  er as normalView,
  nr as normalWorld,
  sr as normalize,
  rr as not,
  cr as notEqual,
  ar as numWorkgroups,
  ir as objectDirection,
  lr as objectGroup,
  mr as objectPosition,
  pr as objectScale,
  dr as objectViewPosition,
  ur as objectWorldMatrix,
  gr as oneMinus,
  hr as or,
  fr as orthographicDepthToViewZ,
  xr as oscSawtooth,
  br as oscSine,
  wr as oscSquare,
  vr as oscTriangle,
  Sr as output,
  Tr as outputStruct,
  _r as overlay,
  Vr as overloadingFn,
  yr as parabola,
  Dr as parallaxDirection,
  Mr as parallaxUV,
  Fr as parameter,
  Cr as pass,
  Ir as passTexture,
  Nr as pcurve,
  Pr as perspectiveDepthToViewZ,
  Rr as pmremTexture,
  Br as pointUV,
  Lr as pointWidth,
  kr as positionGeometry,
  Ar as positionLocal,
  Gr as positionPrevious,
  Or as positionView,
  Wr as positionViewDirection,
  jr as positionWorld,
  Ur as positionWorldDirection,
  qr as posterize,
  zr as pow,
  Er as pow2,
  Zr as pow3,
  Xr as pow4,
  Yr as property,
  Hr as radians,
  Jr as rand,
  Kr as range,
  Qr as rangeFog,
  $r as rangeFogFactor,
  tc as reciprocal,
  oc as reference,
  ec as referenceBuffer,
  nc as reflect,
  sc as reflectVector,
  rc as reflectView,
  cc as reflector,
  ac as refract,
  ic as refractVector,
  lc as refractView,
  mc as reinhardToneMapping,
  pc as remainder,
  dc as remap,
  uc as remapClamp,
  gc as renderGroup,
  hc as renderOutput,
  fc as rendererReference,
  xc as rotate,
  bc as rotateUV,
  wc as roughness,
  vc as round,
  Sc as rtt,
  Tc as sRGBTransferEOTF,
  _c as sRGBTransferOETF,
  Vc as sampler,
  yc as saturate,
  Dc as saturation,
  Mc as screen,
  Fc as screenCoordinate,
  Cc as screenSize,
  Ic as screenUV,
  Nc as scriptable,
  Pc as scriptableValue,
  Rc as select,
  Bc as setCurrentStack,
  Lc as shaderStages,
  kc as shadow,
  Ac as shadowPositionWorld,
  Gc as sharedUniformGroup,
  Oc as sheen,
  Wc as sheenRoughness,
  jc as shiftLeft,
  Uc as shiftRight,
  qc as shininess,
  zc as sign,
  Ec as sin,
  Zc as sinc,
  Xc as skinning,
  Yc as skinningReference,
  Hc as smoothstep,
  Jc as smoothstepElement,
  Kc as specularColor,
  Qc as specularF90,
  $c as spherizeUV,
  ta as split,
  oa as spritesheetUV,
  ea as sqrt,
  na as stack,
  sa as step,
  ra as storage,
  ca as storageBarrier,
  aa as storageObject,
  ia as storageTexture,
  la as string,
  ma as sub,
  pa as subgroupIndex,
  da as subgroupSize,
  ua as tan,
  ga as tangentGeometry,
  ha as tangentLocal,
  fa as tangentView,
  xa as tangentWorld,
  ba as temp,
  wa as texture,
  va as texture3D,
  Sa as textureBarrier,
  Ta as textureBicubic,
  _a as textureCubeUV,
  Va as textureLoad,
  ya as textureSize,
  Da as textureStore,
  Ma as thickness,
  Fa as threshold,
  Ca as time,
  Ia as timerDelta,
  Na as timerGlobal,
  Pa as timerLocal,
  Ra as toOutputColorSpace,
  Ba as toWorkingColorSpace,
  La as toneMapping,
  ka as toneMappingExposure,
  Aa as toonOutlinePass,
  Ga as transformDirection,
  Oa as transformNormal,
  Wa as transformNormalToView,
  ja as transformedBentNormalView,
  Ua as transformedBitangentView,
  qa as transformedBitangentWorld,
  za as transformedClearcoatNormalView,
  Ea as transformedNormalView,
  Za as transformedNormalWorld,
  Xa as transformedTangentView,
  Ya as transformedTangentWorld,
  Ha as transmission,
  Ja as transpose,
  Ka as tri,
  Qa as tri3,
  $a as triNoise3D,
  ti as triplanarTexture,
  oi as triplanarTextures,
  ei as trunc,
  ni as tslFn,
  si as uint,
  ri as uniform,
  ci as uniformArray,
  ai as uniformGroup,
  ii as uniforms,
  li as userData,
  mi as uv,
  pi as uvec2,
  di as uvec3,
  ui as uvec4,
  gi as varying,
  hi as varyingProperty,
  fi as vec2,
  xi as vec3,
  bi as vec4,
  wi as vectorComponents,
  vi as velocity,
  Si as vertexColor,
  Ti as vertexIndex,
  _i as vibrance,
  Vi as viewZToLogarithmicDepth,
  yi as viewZToOrthographicDepth,
  Di as viewZToPerspectiveDepth,
  Mi as viewport,
  Fi as viewportBottomLeft,
  Ci as viewportCoordinate,
  Ii as viewportDepthTexture,
  Ni as viewportLinearDepth,
  Pi as viewportMipTexture,
  Ri as viewportResolution,
  Bi as viewportSafeUV,
  Li as viewportSharedTexture,
  ki as viewportSize,
  Ai as viewportTexture,
  Gi as viewportTopLeft,
  Oi as viewportUV,
  Wi as wgsl,
  ji as wgslFn,
  Ui as workgroupArray,
  qi as workgroupBarrier,
  zi as workgroupId,
  Ei as workingToColorSpace,
  Zi as xor
};
